import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: "01ete",
      title: "01. Custom Game Development & Multiplayer Platforms",
      intitle: "Custom Game Development & Multiplayer Platforms",
      icon: "/assets/svg/industries/game-sport/01.svg",
      content:
         "We develop custom video games with stunning graphics, real-time multiplayer integration, and immersive storytelling. Our solutions include seamless matchmaking, interactive team-based mechanics, and co-op gameplay. We implement physics-based mechanics, dynamic AI opponents, and adaptive difficulty levels. With cross-platform compatibility, customizable avatars, and voice chat integration, we deliver rich, engaging, and competitive gaming experiences.",
   },
   {
      id: "02ete",
      title: "02. Esports & Fantasy Sports Platforms",
      intitle: "Esports & Fantasy Sports Platforms",
      icon: "/assets/svg/industries/game-sport/02.svg",
      content:
         "We create esports and fantasy sports platforms with tournament hosting, live streaming, and automated bracket generation. Our solutions offer real-time match tracking, player drafts, and customizable point-based scoring systems. We integrate social engagement features, leaderboards, and in-app purchases. With live betting options, fan forums, and AI-powered game analysis, we enhance interactive and competitive gaming experiences.",
   },
   {
      id: "03ete",
      title: "03. AI-Powered Game & Sports Analytics",
      intitle: "AI-Powered Game & Sports Analytics",
      icon: "/assets/svg/industries/game-sport/03.svg",
      content:
         "We build AI-driven analytics platforms that track player behavior, match outcomes, and in-game performance. Our solutions offer real-time performance insights, predictive modeling, and personalized game recommendations. We deploy machine learning algorithms to identify patterns, detect vulnerabilities, and provide optimal recommendations. We enable data-driven decisions by teams, coaches, and developers with automated reports, visual dashboards, and detailed metrics.",
   },
   {
      id: "04ete",
      title: "04. Blockchain-Powered Gaming Solutions",
      intitle: "Blockchain-Powered Gaming Solutions",
      icon: "/assets/svg/industries/game-sport/04.svg",
      content:
         "We create blockchain-based games with NFT assets within the game, smart contracts, and tokenized transactions that are secure. Our solutions facilitate play-to-earn mechanisms, ownership of digital assets, and decentralized economies within the game. We implement secure wallets, token exchanges, and NFT marketplaces. With verifiable rarity, cross-platform interoperability, and transparent in-game asset trading, we empower players and developers with new monetization opportunities.",
   },
   {
      id: "05ete",
      title: "05. IoT & Wearable Sports Tracking Solutions",
      intitle: "IoT & Wearable Sports Tracking Solutions",
      icon: "/assets/svg/industries/game-sport/05.svg",
      content:
         "We create IoT-powered sports solutions that track athlete movements, biometrics, and fitness levels. Our platforms integrate with wearables to monitor heart rate, speed, and physical performance in real time. We use AI-driven injury prevention, performance enhancement, and fatigue analysis. With data-driven analysis, remote tracking, and customized training programs, we improve athletic performance and safety.",
   },
   {
      id: "06ete",
      title: "06. Cloud Gaming Infrastructure & Game Streaming",
      intitle: "Cloud Gaming Infrastructure & Game Streaming",
      icon: "/assets/svg/industries/game-sport/06.svg",
      content:
         "We develop cloud gaming platforms that deliver high-end games on any device without downloads. Our solutions offer low-latency streaming, instant game access, and adaptive resolution for optimal performance. We implement scalable infrastructure, automated load balancing, and real-time synchronization. With multiplayer support, cross-platform compatibility, and dynamic resource allocation, we ensure smooth and lag-free gaming experiences.",
   },
]; 
 
function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Comprehensive Gaming & Sports Solutions Software Development
               Services
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               We offer cutting-edge gaming and sports software development solutions, using AI, blockchain, cloud computing, and IoT to assist companies in maximizing user engagement, gameplay optimization, and sports management innovation. Our solutions cover game development, esports platforms, sports analytics, fantasy leagues, and AI-based performance tracking, making digital transformation a smooth process.
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
